export const CATEGORY_OPTIONS = [
  'Moradia',
  'Saúde',
  'Lazer',
  'Cartão de crédito',
  'Compras',
  'Contas Fixas',
  'Assinaturas',
  'Serviços',
  'Educação',
  'Alimentação',
  'Outros',
] as const;

export type CategoryOption = (typeof CATEGORY_OPTIONS)[number];
